export const clampNumRows = (value) => {
    const parsed = parseInt(value, 10)
    if (Number.isNaN(parsed) || parsed <= 0) return 1
    return Math.max(1, Math.min(3, parsed))
}

export const getNumRows = (obj) => clampNumRows(obj?.numRows ?? obj?.num_rows ?? 1)

export const resetButtonCell = (cell) => {
    if (!cell) return
    cell.articleCode = "--"
    cell.deepLink = "--"
    cell.description = "--"
    cell.eanCode = "--"
    cell.pvp = "--"
    cell.relatedArticles = "--"
    cell.numCalls = "--"
    cell.numColumns = "--"
    cell.src = "--"
    cell.toolTip = "--"
    cell.idCategory = "--"
    cell.category = "--"
    cell.numRows = 1
    cell.occupied = false
    cell.occupiedBy = null
}

const isCellEmptyAndFree = (cell) => {
    if (!cell) return false
    if (cell.occupied) return false
    return cell.articleCode === "--" || cell.src === "--"
}

export const canPlacePushButton = (buttonsContent, startIdButton, numRows) => {
    if (!Array.isArray(buttonsContent) || buttonsContent.length === 0) return false

    const start = parseInt(startIdButton, 10)
    if (Number.isNaN(start) || start < 1) return false

    const rows = clampNumRows(numRows)
    const end = start + rows - 1
    if (end > buttonsContent.length) return false

    const startCell = buttonsContent.find(b => b.idButton === start)
    if (startCell?.occupied && startCell?.occupiedBy !== start) return false

    for (let pos = start + 1; pos <= end; pos++) {
        const cell = buttonsContent.find(b => b.idButton === pos)
        if (!cell) return false

        if (cell.occupied) {
            if (cell.occupiedBy === start) continue
            return false
        }

        const isEmpty = cell.articleCode === "--" || cell.src === "--"
        if (!isEmpty) return false
    }

    return true
}

export const releaseOccupiedByStart = (buttonsContent, startIdButton) => {
    if (!Array.isArray(buttonsContent) || buttonsContent.length === 0) return

    const start = parseInt(startIdButton, 10)
    if (Number.isNaN(start) || start < 1) return

    const startCell = buttonsContent.find(b => b.idButton === start)
    const existingNumRows = clampNumRows(startCell?.numRows ?? 1)
    if (existingNumRows <= 1) return

    buttonsContent.forEach(cell => {
        if (cell?.occupied && cell?.occupiedBy === start) resetButtonCell(cell)
    })
}

export const applyPushButtonAt = (buttonsContent, startIdButton, newButtonContent) => {
    if (!Array.isArray(buttonsContent) || buttonsContent.length === 0) return false

    const start = parseInt(startIdButton, 10)
    if (Number.isNaN(start) || start < 1) return false

    const numRows = getNumRows(newButtonContent)

    // Liberamos celdas ocupadas previas del mismo inicio
    releaseOccupiedByStart(buttonsContent, start)

    if (!canPlacePushButton(buttonsContent, start, numRows)) return false

    const startCell = buttonsContent.find(b => b.idButton === start)
    if (!startCell) return false

    startCell.articleCode = newButtonContent.articleCode
    startCell.deepLink = newButtonContent.deepLink
    startCell.description = newButtonContent.description
    startCell.eanCode = newButtonContent.eanCode
    startCell.pvp = newButtonContent.pvp
    startCell.relatedArticles = newButtonContent.relatedArticles
    startCell.numCalls = newButtonContent.numCalls
    startCell.numColumns = newButtonContent.numColumns
    startCell.src = newButtonContent.src
    startCell.toolTip = newButtonContent.toolTip
    startCell.idCategory = newButtonContent.idCategory
    startCell.category = newButtonContent.category
    startCell.numRows = numRows
    startCell.occupied = false
    startCell.occupiedBy = null

    if (numRows > 1) {
        for (let pos = start + 1; pos <= start + numRows - 1; pos++) {
            const cell = buttonsContent.find(b => b.idButton === pos)
            if (!cell) continue
            resetButtonCell(cell)
            cell.occupied = true
            cell.occupiedBy = start
        }
    }

    return true
}

export const findFirstAvailableStart = (buttonsContent, numRows) => {
    if (!Array.isArray(buttonsContent) || buttonsContent.length === 0) return null

    const rows = clampNumRows(numRows)

    for (let start = 1; start <= buttonsContent.length; start++) {
        const end = start + rows - 1
        if (end > buttonsContent.length) continue

        const startCell = buttonsContent.find(b => b.idButton === start)
        if (!isCellEmptyAndFree(startCell)) continue

        let ok = true
        for (let pos = start + 1; pos <= end; pos++) {
            const cell = buttonsContent.find(b => b.idButton === pos)
            if (!isCellEmptyAndFree(cell)) { ok = false; break }
        }
        if (!ok) continue

        return start
    }

    return null
}

export const applySingleRowPushButtonToAllContents = (contents, newButtonContent) => {
    if (!Array.isArray(contents) || contents.length === 0) return false
    if (getNumRows(newButtonContent) > 1) return false

    for (let i = 0; i < contents.length; i++) {
        const subPlateContentAdd = contents[i]?.subPlateContent
        for (let j = 0; j < (subPlateContentAdd ? subPlateContentAdd.length : 0); j++) {
            const buttonsContentAdd = subPlateContentAdd[j]?.slotContent?.buttonsContent
            for (let k = 0; k < (buttonsContentAdd ? buttonsContentAdd.length : 0); k++) {
                const buttonContentAdd = buttonsContentAdd[k]
                if (!buttonContentAdd || buttonContentAdd.occupied) continue

                if (buttonContentAdd.src === "--" || buttonContentAdd.articleCode === "--") {
                    buttonContentAdd.articleCode = newButtonContent.articleCode
                    buttonContentAdd.deepLink = newButtonContent.deepLink
                    buttonContentAdd.description = newButtonContent.description
                    buttonContentAdd.eanCode = newButtonContent.eanCode
                    buttonContentAdd.pvp = newButtonContent.pvp
                    buttonContentAdd.relatedArticles = newButtonContent.relatedArticles
                    buttonContentAdd.numCalls = newButtonContent.numCalls
                    buttonContentAdd.numColumns = newButtonContent.numColumns
                    buttonContentAdd.src = newButtonContent.src
                    buttonContentAdd.toolTip = newButtonContent.toolTip
                    buttonContentAdd.idCategory = newButtonContent.idCategory
                    buttonContentAdd.category = newButtonContent.category
                    buttonContentAdd.numRows = 1
                    buttonContentAdd.occupied = false
                    buttonContentAdd.occupiedBy = null
                }
            }
        }
    }

    return true
}
